export default __webpack_public_path__ + "static/media/cursor-move.807b9160.svg";